
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class WxhhTable extends Vue {
    //五星宏辉
    table = {
        data: [],
        column: [
            {
                key: 'spade',
                title: '下注黑桃',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.spade) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.spade.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'heart',
                title: '下注红桃',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.heart) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.heart.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'club',
                title: '下注梅花',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.club) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.club.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'diamond',
                title: '下注方块',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.diamond) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.diamond.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'joker',
                title: '下注joker',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.joker) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.joker.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '开奖结果',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    let numColor = 0
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        str = JSON.parse(params.row.opt_detail).award_content.point.card
                        numColor = JSON.parse(params.row.opt_detail).award_content.hit.win_color
                        if (numColor == 2) {
                            str = str - 16
                        } else if (numColor == 1) {
                            str = str + 16
                        } else if (numColor == 0) {
                            str = str + 48
                        } else if (numColor == 3) {
                            str = str + 16
                        } else if (numColor == 4) {
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: typeof str != 'number' ? '' : "<img style='width:35px;' src=img/poker/" + str + '.png>'
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        if (arr[key].bet) {
                            str += (this as any).getMoney(arr[key].bet, 1)
                        }
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h('span', { style: { color: color } }, str)
                }
            }
        ]
    }

    @Prop()
    listdata
}
